import { render, staticRenderFns } from "./FArticleTable.vue?vue&type=template&id=c6dad97a&scoped=true"
import script from "./FArticleTable.vue?vue&type=script&lang=js"
export * from "./FArticleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dad97a",
  null
  
)

export default component.exports